import React from 'react';
export function Button({
  variant = 'primary',
  className = '',
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: 'primary' | 'secondary' | 'danger' | 'ghost' }) {
  return <button className={`btn btn-${variant} ${className}`} {...props} />;
}
export function Field({
  label,
  id,
  help,
  error,
  required,
  children,
  className = '',
}: {
  label: string;
  id: string;
  help?: string;
  error?: string;
  required?: boolean;
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={`field ${className}`}>
      <label htmlFor={id}>
        {label}
        {required && <span aria-hidden="true"> *</span>}
      </label>
      {children}
      {help && <small className="helper">{help}</small>}
      {error && (
        <small className="field-error" role="alert">
          {error}
        </small>
      )}
    </div>
  );
}
export function Section({
  id,
  title,
  description,
  status,
  children,
}: {
  id: string;
  title: string;
  description?: string;
  status?: 'complete' | 'pending' | 'blocked';
  children?: React.ReactNode;
}) {
  return (
    <section id={id} className={`proposal-section ${status || ''}`}>
      <header>
        <div>
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
        {status && (
          <span className={`section-status ${status}`}>
            {status === 'complete' ? 'Concluída' : status === 'blocked' ? 'Atenção' : 'Pendente'}
          </span>
        )}
      </header>
      <div className="section-body">{children}</div>
    </section>
  );
}
export function Notice({
  tone = 'info',
  title,
  children,
}: {
  tone?: 'info' | 'warning' | 'danger' | 'success';
  title: string;
  children?: React.ReactNode;
}) {
  return (
    <div className={`notice notice-${tone}`} role={tone === 'danger' ? 'alert' : 'status'}>
      <strong>{title}</strong>
      <div>{children}</div>
    </div>
  );
}
export function Empty({ title, children, action }: { title: string; children?: React.ReactNode; action?: React.ReactNode }) {
  return (
    <div className="empty">
      <h3>{title}</h3>
      <p>{children}</p>
      {action}
    </div>
  );
}
